import React, { RefObject } from "react";
import Level from "./Level2";
import Monument from "./Monument";
import {
  Button,
  HStack,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Link,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Spacer,
  Skeleton,
  Text,
} from "@chakra-ui/react";
import { mapNames } from "../../../Utils";
import { colors } from "../../../Theme";
import { useAppDispatch, useAppSelector } from "../../../Store/hooks";
import {
  setModalOpen,
  setCategory,
  setLevel,
  ModalsName,
} from "../../../Store/ModalsReducer";
import Group from "./Group";
import CoveringMaster, { ItemInfo } from "./CoveringMaster";
import { ActionTypes, addAction } from "../../../Store/ActionsHistoryReducer";

type Level1Props = {
  next: Function;
};

type Level2Props = {
  prev: Function;
  category: string;
  addModel: (
    data: {
      dirname: string;
      obj: string;
      mtl: string;
    },
    category: string,
    id: number
  ) => void;
  addGroup: (id: number) => Promise<void>;
  next: () => void;
};

const Level1 = (props: Level1Props) => {
  return (
    <HStack spacing="4" p={5}>
      <Link onClick={() => props.next("monument")} w={150}>
        <Image
          src={process.env.PUBLIC_URL + "/images/modals/monument.png"}
          alt="Памятники"
          fallback={<Skeleton />}
        />
      </Link>
      <Link onClick={() => props.next("tombstone")} w={150}>
        <Image
          src={process.env.PUBLIC_URL + "/images/modals/tombstone.png"}
          alt="Цветники"
          fallback={<Skeleton />}
        />
      </Link>
      <Link onClick={() => props.next("covering")} w={150}>
        <Image
          src={process.env.PUBLIC_URL + "/images/modals/covering.png"}
          alt="Покрытия"
          fallback={<Skeleton />}
        />
      </Link>
      <Link onClick={() => props.next("fence")} w={150}>
        <Image
          src={process.env.PUBLIC_URL + "/images/modals/fence.png"}
          alt="Ограды"
          fallback={<Skeleton />}
        />
      </Link>
      <Link onClick={() => props.next("accessory")} w={150}>
        <Image
          src={process.env.PUBLIC_URL + "/images/modals/accessory.png"}
          alt="Аксессуары"
          fallback={<Skeleton />}
        />
      </Link>
      <Link onClick={() => props.next("element")} w={150}>
        <Image
          src={process.env.PUBLIC_URL + "/images/modals/element.png"}
          alt="Элементы"
          fallback={<Skeleton />}
        />
      </Link>
      {/* <Link onClick={() => props.next("group")} w={150}>
        Группы
      </Link> */}
    </HStack>
  );
};

const Level2 = (props: Level2Props) => {
  const movingNodes = useAppSelector((state) => state.main.movingNodes);
  const types = useAppSelector((state) => state.main.types);
  const category =
    movingNodes.length > 0 ? types[movingNodes[0]] : props.category;
  return (
    <>
      {movingNodes.length === 0 && (
        <HStack marginTop={3} marginBottom={3}>
          <Breadcrumb>
            <BreadcrumbItem>
              <BreadcrumbLink onClick={() => props.prev()}>Меню</BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink href="#">{mapNames(category)}</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
          <Spacer />
          <Text
            cursor="pointer"
            onClick={() => window.open("/kgrowlMessage2?uid=1")}
            fontStyle="italic"
          >
            Нужна другая модель? Обратитесь к администратору
          </Text>
          <Spacer />
          <Button variant="editor" onClick={() => props.prev()}>
            Назад
          </Button>
        </HStack>
      )}
      {category === "monument" && <Monument addModel={props.addModel} />}
      {category === "group" && <Group addGroup={props.addGroup} />}
      {category !== "monument" && category !== "group" && (
        <Level
          category={category}
          addModel={props.addModel}
          next={props.next}
        />
      )}
    </>
  );
};

const ModalAdd = (props: {
  canvasRef: RefObject<HTMLCanvasElement>;
  addModel: (obj: string, mtl: string, category: string, id: number) => Promise<string>;
  addGroup: (id: number) => Promise<void>;
  createCovering: (args: {
    x: number;
    model: ItemInfo;
    z: number;
    fill: boolean;
    name: string;
  }) => Promise<string>;
}) => {
  const isOpen = useAppSelector((state) => state.modals[ModalsName.ADD].isOpen);
  const category = useAppSelector(
    (state) => state.modals[ModalsName.ADD].category
  );
  const level = useAppSelector((state) => state.modals[ModalsName.ADD].level);
  const dispatch = useAppDispatch();
  const movingNodes = useAppSelector(state => state.main.movingNodes);
  // const ids = useAppSelector(state => state.main.ids);

  const addModel = async (
    data: {
      obj: string;
      mtl: string;
      dirname: string;
    },
    category: string,
    id: number
  ) => {
    const obj = `${data.dirname}/${data.obj}`;
    const mtl = `${data.dirname}/${data.mtl}`;
    const addedKey = await props.addModel(obj, mtl, category, id);
    if (movingNodes.length > 0) {
      // dispatch(addAction({
      //   type: ActionTypes.REPLACE_MODEL,
      //   data: {
      //     keys: addedKey,
      //     model: {
      //       from: ids[movingNodes[0]],
      //       to: id
      //     }
      //   }
      // }));
    } else {
      dispatch(addAction({
        type: ActionTypes.ADD_MODEL,
        data: {
          keys: addedKey,
          model: {
            from: 0,
            to: id
          }
        }
      }));
    }
    dispatch(setLevel(1));
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() =>
          dispatch(setModalOpen({ key: ModalsName.ADD, value: false }))
        }
        size={level === 1 ? "6xl" : "max"}
        isCentered={true}
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent
          onScrollCapture={(ev) => {
            console.log("scrolled", ev);
          }}
          maxH="80vh"
          w={level !== 1 ? "80%" : "auto"}
          bg={colors.badgeLight}
        >
          <ModalBody>
            {level === 1 && (
              <Level1
                next={(category: string) => dispatch(setCategory(category))}
              />
            )}
            {level === 2 && (
              <Level2
                prev={() => dispatch(setLevel(1))}
                category={category}
                addModel={addModel}
                addGroup={props.addGroup}
                next={() => {
                  console.log("next");
                  dispatch(setLevel(3));
                }}
              />
            )}
            {level === 3 && (
              <CoveringMaster createCovering={props.createCovering} />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default ModalAdd;
